import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "22.475",
  width: "50",
  viewBox: "0 0 50 22.475",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M22.323 9.5c-.86-5.556-5.505-9.495-11.11-9.495C5 .005 0 5.005 0 11.205c0 6.212 5.05 11.263 11.212 11.263 5.606 0 10.253-3.89 11.11-9.444h12.02v5.05h3.536v-5.05h2.526v5.05h3.535v-5.05h2.522v5.05H50V9.488H22.323zm-11.06 9.394c-4.243 0-7.678-3.434-7.678-7.677S7.02 3.54 11.262 3.54c4.242 0 7.677 3.435 7.677 7.677s-3.438 7.677-7.68 7.677z"
  })]
});